<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <b-card class="backClass" header="Received">
        <Modal
          title="Choose period"
          class="modal-primary"
          v-model="modalDate"
          @on-ok="fetchData(), (modalDate = false)"
          :transfer="false"
        >
          <b-form>
            <b-form-group label="From" label-for="date" :label-cols="3">
              <datepicker use-utc
                format="MM/dd/yyyy"
                :bootstrap-styling="true"
                v-model="dateFrom"
                name="dateFrom"
              ></datepicker>
            </b-form-group>
            <b-form-group label="To" label-for="dateTo" :label-cols="3">
              <datepicker use-utc
                format="MM/dd/yyyy"
                :bootstrap-styling="true"
                v-model="dateTo"
                name="dateTo"
              ></datepicker>
            </b-form-group>
          </b-form>
        </Modal>

        <!-- MODAL FOR LOCATIONS -->
        <Modal
          size="lg"
          title="Choose location"
          class="modal-primary backlogCities"
          v-model="modalView"
          @on-ok="modalView = false"
          :transfer="false"
        >
          <b-form-input
            style="display:inline-block; width:250px;"
            v-model="searchQuery"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
          ></b-form-input>

          <hr />
          <div
            style="height: 400px; padding-top: 150px"
            v-if="!dataReady"
            class="loading"
          >
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <b-row v-else style="padding:2em;">
            <template v-for="location in filterItems(locations)">
              <b-col lg="4" sm="6" :key="location.id" style="padding: 5px;">
                <a
                  class="locationLabels"
                  style="font-size:1.2em;"
                  :href="
                    '#/base/city/?loc=' +
                      location.id +
                      '&city=' +
                      location.location +
                      '&lat=' +
                      location.lat +
                      '&lng=' +
                      location.lng
                  "
                  v-b-tooltip.hover
                  :title="location.id + ' - ' + location.contact"
                  >{{ location.location }} ({{ location.delivered }})</a
                >
              </b-col>
            </template>
          </b-row>
        </Modal>

        <div slot="header">
          <h5 style="display: inline;" class="card-title mb-0">
            Delivered Equipment
            <small style="font-weight:600; color:#20a8d8">
              {{ from ? $formatUSDate(from) : $formatUSDate(dateFrom) }}
              <b>|</b>
              {{ to ? $formatUSDate(to) : $formatUSDate(dateTo) }}
            </small>
            <b-button
              v-if="details == 1"
              @click="detailView"
              class="btn-outline btn-sm ml-3"
              variant="outline-primary"
              right
            >
              Back
            </b-button>
          </h5>
          <div class="card-header-actions">
            <!-- <b-button
              @click="toggleFullScreen"
              style="height: 26px; width: 26px"
              class="float-right"
              variant="transparent p-0"
              right
            >
              <i style="color: #20a8d8;" class="icon-frame"></i>
            </b-button> -->

            <b-button
              @click="modalDateEvent"
              class
              style="height: 26px; width: 26px"
              variant="transparent p-0"
            >
              <i class="icon-calendar" style="color: #20a8d8;"></i>
            </b-button>
            <b-button
              class="btn"
              style="height: 26px; width: 26px"
              variant="transparent p-0"
              attr="pdf"
              @click="downloadPDF()"
            >
              <i
                class="fa fa-file-pdf-o"
                style="color: rgb(32, 168, 216);"
                aria-hidden="true"
              ></i>
            </b-button>
          </div>
        </div>

        <div style="width: 100%; display: flex; justify-content: flex-end;">
          <h5>Quantity</h5>
          <c-switch
            class="mx-1"
            color="primary"
            v-model="valueQuantity"
            value="true"
            uncheckedValue="false"
            variant="pill"
          />
          <h5>Financials</h5>
        </div>

        <div class="chart-wrapper">
          <b-button
            v-if="details == 1"
            @click="changeCharty"
            class="btn-outline btn-sm ml-1"
            variant="outline-primary"
            right
          >
            Product Groups Total
          </b-button>
          <b-button
            @click="modalView = true"
            v-if="(details = 1)"
            class="btn-outline btn-sm ml-1"
            variant="outline-primary"
            right
          >
            By Location
          </b-button>

          <div
            style="height: 400px; padding-top: 150px"
            v-if="loadingData"
            class="loading"
          >
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <highcharts
            ref="backRef"
            v-else-if="!loadingData && changeChart == false"
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
          <ChartModels
            v-else-if="changeChart == true"
            :dateFrom="dateFrom"
            :dateTo="dateTo"
          ></ChartModels>
        </div>
        <div style="width: 100%; display: flex; justify-content: flex-end;">
          <b-form-checkbox
            id="checkbox-ship"
            class="mx-1"
            v-if="changeChart == false"
            v-model="toggleData"
            name="checkbox-ship"
            value="true"
            unchecked-value="false"
            >Show / Hide All</b-form-checkbox
          >
        </div>
        <div slot="footer">
          <b-button
            :disabled="!showAll"
            class="btn-outline"
            v-if="changeChart == false"
            variant="outline-primary"
            left
            @click="(showAll = false), fetchData()"
            >Top 10</b-button
          >

          <b-button
            :disabled="showAll"
            v-if="changeChart == false"
            class="btn-outline float-right"
            variant="outline-primary"
            right
            @click="(showAll = true), fetchData()"
            >All Data</b-button
          >

          <b-button
            class="btn-outline text"
            style="margin-right:10px; float:right"
            variant="outline-primary"
            @click="
              () =>
                $router.push(
                  '/base/TableAllData?type=Shipped&date_from=' +
                    (from ? from : dateFrom) +
                    '&date_to=' +
                    (to ? to : dateTo)
                )
            "
            >Overall Data</b-button
          >
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../router";
import Datepicker from "vuejs-datepicker";
import { Switch as cSwitch } from "@coreui/vue";
import iView from "iview";
import ChartModels from "./ProductModel-Delivered";

export default {
  name: "ActiveBacklog-Stacked",
  components: {
    router,
    highcharts: Chart,
    cSwitch,
    iView,
    Datepicker,
    ChartModels
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity", "nameCity", "details"],
  data: function() {
    return {
      fullscreen: false,
      modalView: false,
      dataReady: false,
      changeChart: false,
      locations: [],
      searchQuery: "",
      loadingData: false,
      showAll: false,
      modalDate: 0,
      totalValue: null,
      valueQuantity: false,
      toggleData: false,
      dateFrom: "",
      dateTo: "",
      locationName: "",
      productGroup: "",
      locationsIds: "",
      chartOptions: {
        tooltip: {
          formatter: function() {
            return;
          }
        },
        chart: {
          type: "column",
          backgroundColor: "transparent"
        },
        exporting: {
          enabled: true
        },
        title: {
          text: "",
          style: {
            color: "white",
            display: ""
          }
        },
        legend: {
          itemStyle: {
            color: "white"
          }
        },
        xAxis: {
          categories: [],
          labels: {
            style: {
              color: "white"
            }
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: "Product Group By City"
          },
          labels: {
            style: {
              color: "white"
            }
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: "bold",
              color: "white"
            }
          }
        },
        plotOptions: {
          column: {
            stacking: "normal",
            dataLabels: {
              enabled: true,
              formatter: function() {
                return "TEST";
              }
            },
            events: {
              legendItemClick: data => {
                this.totalValue = null;
              }
            },
            point: {
              events: {
                click: ({ point }) => {
                  router.push(
                    "/base/Tables/?location=" +
                      point.category +
                      "%284%29" +
                      "&productGroup=" +
                      point.series.name +
                      "%284%29" +
                      "&type=Shipped&date_from=" +
                      this.dateFrom +
                      "&date_to=" +
                      this.dateTo
                  );
                }
              }
            }
          },
          series: {
            point: {
              events: {
                click: ({ point }) => {
                  console.log(point.series.name);
                  console.log(point.category);
                  console.log(point.y);
                }
              }
            }
          }
        },
        series: []
      }
    };
  },

  watch: {
    totalValue(value) {
      var chartSeries = this.$refs.backRef.chart.series;
      var pointSum = 0;
      chartSeries.forEach(function(obj) {
        if (obj.visible == true) {
          obj.yData.forEach(function(datas) {
            pointSum += datas;
          });
        }
      });
      this.totalValue = pointSum;
      if (!this.valueQuantity || this.valueQuantity == "false") {
        this.chartOptions.title.text = "Total units: " + this.totalValue;
      } else {
        this.chartOptions.title.text =
          "Total: " +
          "$" +
          this.totalValue
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
      }
    },
    fullscreen(value) {
      if (value == false) {
        this.detailView();
      }
    },
    valueQuantity(value) {
      this.fetchData();
    },
    toggleData(param) {
      var chartSeries = this.$refs.backRef.chart.series;
      console.log(param);
      chartSeries.forEach(obj => {
        if (param === "false") {
          obj.show();
        } else {
          obj.hide();
        }
      });
    }
  },

  methods: {
    detailView() {
      this.$emit("detailViewShip");
    },
    changeCharty() {
      if (this.changeChart == true) {
        this.changeChart = false;
      } else {
        this.changeChart = true;
      }
      console.log(this.changeChart);
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    fetchData() {
      this.loadingData = true;

      let params = {};
      let finType = "Fin";
      if (!this.valueQuantity || this.valueQuantity == "false") {
        finType = "Qty";
      }
      params = {
        type: finType,
        date_from: this.dateFrom,
        date_to: this.dateTo,
        chartType: "Shipped"
      };
      this.$http
        .get("api/fns/charts/chart_data.php", {
          params
        })
        .then(
          res => {
            let getReady = res.data.stackedData;
            let myArray = getReady;
            let xAxis = [];
            var datum = [];

            var fiber = {
              name: "Fiber Gear",
              data: [],
              color: "rgb(124, 181, 236)"
            };
            var power = {
              name: "Power Supply",
              data: [],
              color: "rgb(247, 163, 92)"
            };
            var line = {
              name: "Line Gear",
              data: [],
              color: "rgb(144, 237, 125)"
            };
            var meter = {
              name: "Meter",
              data: [],
              color: "rgb(145, 232, 225)"
            };
            var transponder = {
              name: "Transponder",
              data: [],
              color: "rgb(241, 92, 128)"
            };
            var headend = {
              name: "Headend",
              data: [],
              color: "rgb(43, 144, 143)"
            };
            var wireless = {
              name: "Wireless",
              data: [],
              color: "rgb(23, 114, 143)"
            };

            for (var type in myArray) {
              datum.push([type, myArray[type]]);
            }
            datum.sort((a, b) =>
              parseFloat(a[1].Total) > parseFloat(b[1].Total) ? -1 : 1
            );
            if (!this.showAll) {
              datum = datum.slice(0, 10);
            }

            datum.forEach(obj => {
              xAxis.push(obj[0]);
              Object.entries(obj[1]).forEach(([key, value]) => {
                var tempValue = parseInt(value);

                switch (key) {
                  case "Fiber Gear":
                    fiber.data.push(tempValue);

                    break;
                  case "Power Supply":
                    power.data.push(tempValue);

                    break;
                  case "Line Gear":
                    line.data.push(tempValue);

                    break;
                  case "Meter":
                    meter.data.push(tempValue);

                    break;
                  case "Transponder":
                    transponder.data.push(tempValue);
                    break;
                  case "Headend":
                    headend.data.push(tempValue);
                    break;
                  case "Wireless":
                    wireless.data.push(tempValue);
                    break;
                }
              });
            });
            if (!this.showAll) {
              this.chartOptions.xAxis.categories = xAxis.slice(0, 10);
            } else {
              this.chartOptions.xAxis.categories = xAxis;
            }
            this.chartOptions.series[0] = fiber;
            this.chartOptions.series[1] = power;
            this.chartOptions.series[2] = line;
            this.chartOptions.series[3] = meter;
            this.chartOptions.series[4] = transponder;
            this.chartOptions.series[5] = headend;
            this.chartOptions.series[6] = wireless;

            // Getting total amount wihtout response
            var seriesData = this.chartOptions.series;
            var pointSum = 0;
            seriesData.forEach(function(point) {
              var datasValue = point.data;
              datasValue.forEach(function(value) {
                pointSum += value;
              });
            });
            this.totalValue = pointSum;

            if (finType == "Fin") {
              this.chartOptions.title.text =
                "Total: " +
                "$" +
                this.totalValue
                  .toFixed(2)
                  .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");

              this.chartOptions.tooltip.formatter = function() {
                return (
                  "<b>" +
                  this.x +
                  "</b><br>" +
                  this.series.name +
                  ": $" +
                  this.y
                );
              };

              this.chartOptions.plotOptions.column.dataLabels.formatter = function() {
                return (
                  "$" +
                  this.y
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
                );
              };

              this.chartOptions.yAxis.stackLabels.formatter = function() {
                return (
                  "Total: " +
                  "$" +
                  this.total
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
                );
              };

              this.chartOptions.legend.labelFormatter = function() {
                var dataGet = this.yData;
                var summaryData = 0;
                dataGet.forEach(function(point) {
                  summaryData += point;
                });
                return (
                  "<b>" +
                  this.name +
                  "</b> <small><br>Total: $" +
                  summaryData
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") +
                  "</small>"
                );
              };
            } else {
              this.chartOptions.title.text = "Total units: " + this.totalValue;

              this.chartOptions.tooltip.formatter = function() {
                return (
                  "<b>" +
                  this.x +
                  "</b><br>" +
                  this.series.name +
                  ": " +
                  this.y +
                  " units"
                );
              };

              this.chartOptions.plotOptions.column.dataLabels.formatter = function() {
                return this.y;
              };

              this.chartOptions.yAxis.stackLabels.formatter = function() {
                return "Total: " + this.total;
              };

              this.chartOptions.legend.labelFormatter = function() {
                var dataGet = this.yData;
                var summaryData = 0;
                dataGet.forEach(function(point) {
                  summaryData += point;
                });
                return (
                  "<b>" +
                  this.name +
                  "</b> <small><br>Total: " +
                  summaryData +
                  "</small>"
                );
              };
            }

            if (this.details == 1) {
              this.chartOptions.chart.height = "44%";
            }

            this.loadingData = false;
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
    },
    changeHeight() {
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    modalDateEvent() {
      this.modalDate = 1;
    },

    fetchLocationShip() {
      let params = {};
      params = {
        date_from: this.dateFrom,
        date_to: this.dateTo
      };
      this.$http
        .get("api/fns/charts/locationsDeliveredCount.php", { params })
        .then(
          res => {
            console.log(res.data);
            const parsedData = res.data;
            this.locations = parsedData;
            console.log(this.locations);
            this.dataReady = true;
          },
          err => {
            console.log(err);
          }
        );
    },
    filterItems: function(locations) {
      var app = this;
      return locations.filter(function(location) {
        let regex = new RegExp("(" + app.searchQuery + ")", "i");
        return location.location.match(regex);
      });
    },

    downloadPDF() {
      if (this.locParam == 1) {
        this.$refs.backRef.chart.options.title.text =
          "Delivered Equipment | " + this.dateTo;
      } else {
        this.$refs.backRef.chart.options.title.text =
          "Delivered Equipment | " + this.dateTo + " " + this.nameCity;
      }

      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";
      this.$refs.backRef.chart.options.legend.itemStyle.color = "black";

      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });
      this.$refs.backRef.chart.options.yAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });

      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename: "Delivered-" + this.dateTo
      });

      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
      this.$refs.backRef.chart.options.legend.itemStyle.color = "white";
    }
  },
  computed: {
    from() {
      if (typeof this.dateFrom === "object") {
        this.dateFrom = this.dateFrom.toISOString().split("T")[0];
        return this.dateFrom;
      }
    },
    to() {
      if (typeof this.dateTo === "object") {
        this.dateTo = this.dateTo.toISOString().split("T")[0];
        return this.dateTo;
      }
    }
  },
  mounted() {
    if (!localStorage.getItem("fns_user")) {
      router.push("/pages/login/");
    }

    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("locations");
    } else {
      this.locationsIds = this.idCity;
    }

    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.fetchData();

    if (this.details == 1) {
      this.toggleFullScreen();
      this.fetchLocationShip();
    }
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}

.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}

.ivu-modal-content {
  background: #3a4149 !important;
}
.cities .ivu-modal {
  width: 660px !important;
}
.ivu-modal-header p,
.ivu-modal-header-inner {
  color: white !important;
  font-size: 1.09375rem;
  font-weight: 500;
}
.ivu-modal-header {
  border-bottom: 1px solid #23282c !important;
  padding: 1rem;
}
.ivu-btn-text {
  color: #23282c;
  background-color: #acb5bc;
  border-color: #a5aeb7;
}
</style>
